/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Feature_VideoInputs */

const en_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video analysis and launch-monitor data`)
};

const es_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis en video y datos de launch monitor`)
};

const de_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoanalyse und Launch-Monitor-Daten`)
};

const zh_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频分析与弹道监测仪数据`)
};

const ar_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحليل بالفيديو وبيانات جهاز تحليل الضربات (launch monitor)`)
};

const fr_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse vidéo et données de launch monitor`)
};

const vi_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân tích video và dữ liệu máy đo quỹ đạo (launch monitor)`)
};

const sw_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uchambuzi wa video na data za launch monitor`)
};

const th_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิเคราะห์วิดีโอและข้อมูลลอนช์มอนิเตอร์`)
};

const bs_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video analiza i podaci sa launch monitora`)
};

const ja_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオ分析とローンチモニターデータ`)
};

const ko_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비디오 분석 및 론치 모니터 데이터`)
};

const pt_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise de vídeo e dados de launch monitor`)
};

const it_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi video e dati del launch monitor`)
};

const sv_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoanalys och data från launch monitor`)
};

const nl_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoanalyse en launchmonitordata`)
};

const da_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoanalyse og launch monitor-data`)
};

const nb_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoanalyse og data fra launch monitor`)
};

const fi_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoanalyysi ja launch monitor -data`)
};

const pl_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analiza wideo i dane z launch monitora`)
};

const ru_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеоанализ и данные launch monitor`)
};

const tr_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video analizi ve launch monitor verileri`)
};

const hi_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो विश्लेषण और लॉन्च मॉनिटर डेटा`)
};

const id_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis video dan data launch monitor`)
};

const ms_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis video dan data launch monitor`)
};

const cs_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analýza videa a data z launch monitoru`)
};

const el_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ανάλυση βίντεο και δεδομένα launch monitor`)
};

const he_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ניתוח וידאו ונתוני launch monitor`)
};

const af_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video-analise en launch monitor-data`)
};

const hu_home_feature_video = /** @type {(inputs: Home_Feature_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videóelemzés és launch monitor adatok`)
};

/**
* | output |
* | --- |
* | "Video analysis and launch-monitor data" |
*
* @param {Home_Feature_VideoInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_feature_video = /** @type {((inputs?: Home_Feature_VideoInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Feature_VideoInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_feature_video(inputs)
	if (locale === "de") return de_home_feature_video(inputs)
	if (locale === "zh") return zh_home_feature_video(inputs)
	if (locale === "ar") return ar_home_feature_video(inputs)
	if (locale === "fr") return fr_home_feature_video(inputs)
	if (locale === "vi") return vi_home_feature_video(inputs)
	if (locale === "sw") return sw_home_feature_video(inputs)
	if (locale === "th") return th_home_feature_video(inputs)
	if (locale === "bs") return bs_home_feature_video(inputs)
	if (locale === "ja") return ja_home_feature_video(inputs)
	if (locale === "ko") return ko_home_feature_video(inputs)
	if (locale === "pt") return pt_home_feature_video(inputs)
	if (locale === "it") return it_home_feature_video(inputs)
	if (locale === "sv") return sv_home_feature_video(inputs)
	if (locale === "nl") return nl_home_feature_video(inputs)
	if (locale === "da") return da_home_feature_video(inputs)
	if (locale === "nb") return nb_home_feature_video(inputs)
	if (locale === "fi") return fi_home_feature_video(inputs)
	if (locale === "pl") return pl_home_feature_video(inputs)
	if (locale === "ru") return ru_home_feature_video(inputs)
	if (locale === "tr") return tr_home_feature_video(inputs)
	if (locale === "hi") return hi_home_feature_video(inputs)
	if (locale === "id") return id_home_feature_video(inputs)
	if (locale === "ms") return ms_home_feature_video(inputs)
	if (locale === "cs") return cs_home_feature_video(inputs)
	if (locale === "el") return el_home_feature_video(inputs)
	if (locale === "he") return he_home_feature_video(inputs)
	if (locale === "af") return af_home_feature_video(inputs)
	if (locale === "hu") return hu_home_feature_video(inputs)
	return en_home_feature_video(inputs)
});